import "./AboutMe.css";
import { Container, Row, Col } from "react-bootstrap/";
import profile from "../images/profile_darkb.svg";
import { useInView } from "react-intersection-observer";

function AboutMe() {
  const { ref: aboutRef, inView: aboutVisible } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const highlights = [
    "Agentic AI Systems",
    "Cloud Architecture",
    "Full-Stack Development",
    "Product Management",
    "AI & ML Research",
  ];

  return (
    <Container fluid className="aboutMeSection py-5" id="aboutMe" ref={aboutRef}>
      <Container className={`${aboutVisible ? "fade-in-up" : "opacity-0"}`}>
        <div className="section-header text-center">
          <h2 className="section-title">About Me</h2>
          <div className="titleHr" />
          <p className="section-subtitle">
            Bridging technical software engineering excellence with enterprise business strategy.
          </p>
        </div>

        <Row className="g-4 align-items-stretch">
          {/* Main Bio Card */}
          <Col xs={12} lg={7}>
            <div className="glass-card p-4 p-md-5 h-100 bioCard">
              <h3 className="bioHeadline mb-3">
                Hello, I'm <span className="highlightText">Div</span>
              </h3>

              <p className="bioParagraph">
                I hold a <strong>Combined Bachelor's Degree in Software Engineering &amp; Business</strong> from the
                University of Calgary. Currently, I am an <strong>Associate Consultant at IBM</strong> specializing in
                <strong> Agentic AI Development</strong> and <strong>Cloud Solutions</strong>.
              </p>

              <p className="bioParagraph">
                My experience spans developing production-grade AI applications, scalable web platforms, cloud-native services, and data-driven solutions.
                Through my work at IBM, BMO, and in academic research, I've enjoyed solving complex engineering problems while delivering software that creates measurable business value.
              </p>

              <p className="bioParagraph">
                Outside of engineering, I really enjoy playing basketball and tennis with my friends and
                exploring the Rockies through a pleasant hike. I have a keen interest in nature photography as
                I love to capture the various landscapes I encounter through my travel adventures.
              </p>

              <div className="chipGrid mt-4">
                {highlights.map((chip, idx) => (
                  <span key={idx} className="badge-pill">
                    ⚡ {chip}
                  </span>
                ))}
              </div>
            </div>
          </Col>

          {/* Quick Info & Profile Card */}
          <Col xs={12} lg={5}>
            <div className="glass-card p-4 h-100 d-flex flex-column justify-content-between profileCard">
              <div className="text-center mb-3">
                <div className="profileSvgContainer">
                  <img loading="lazy" className="profileImg img-fluid" src={profile} alt="Divyansh Profile Illustration" />
                </div>
              </div>

              <div className="quickFactList">
                <div className="factItem">
                  <span className="factIcon">💼</span>
                  <div>
                    <div className="factLabel">Current Role</div>
                    <div className="factValue">Associate Consultant (AI &amp; Cloud) @ IBM</div>
                  </div>
                </div>

                <div className="factItem">
                  <span className="factIcon">🎓</span>
                  <div>
                    <div className="factLabel">Degrees</div>
                    <div className="factValue">B.Sc. Software Engineering &amp; B.Com Business</div>
                  </div>
                </div>

                <div className="factItem">
                  <span className="factIcon">📜</span>
                  <div>
                    <div className="factLabel">Research</div>
                    <div className="factValue">1st Author IEEE SSCI 2021 Publication</div>
                  </div>
                </div>

                <div className="factItem">
                  <span className="factIcon">🏔️</span>
                  <div>
                    <div className="factLabel">Interests</div>
                    <div className="factValue">AI, Web Development, Cloud, Photography, Tennis, Basketball</div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default AboutMe;
